export const CLUB_FIELDS = `
  fragment clubFields on Club {
    _id
    name
    slug
    abbreviation
    logo
    gdpr
    location {
      address
      coordinates
      type
    }
    founded
    country
    sport
    contactInfo {
      phones
      emails
      websiteUrl
    }
    isPremium
    timezone
    clubAdminUsers
  }
`;

export const CLUB_FIELDS_WITH_THEME = `
fragment clubFieldsWithTheme on ClubWithTheme {
    _id
    name
    abbreviation
    logo
    gdpr
    location {
      address
      coordinates
      type
    }
    founded
    country
    sport
    contactInfo {
      phones
      emails
      websiteUrl
    }
    isPremium
    timezone
    theme
    totalMembers
  }
`;

export const CREATE_CLUB = `
  mutation createClub($name: String!, $abbreviation: String, $founded: Int, $country: String!, $sport: String!, $contactInfo: ContactInfoInput, $location: LocationInput, $timezone: String) {
    createClub(name: $name, abbreviation: $abbreviation, founded: $founded, country: $country, sport: $sport, contactInfo: $contactInfo, location: $location, timezone: $timezone) {
      _id
    }
  }
`;

export const GET_CLUB_WEBSITE_SETTINGS = `
  query ($ids: [String]) {
    ResolveClubs(ids: $ids) {
      _id
      slug
      websiteSettings {
        siteEnabled
        showStaff
        showRoster
        showEvents
        showPhotos
        showAttendance
        showPosts
        nameDisplay
        showPlayerPhotos
        aboutText
        showContactInfo
        showContactPhone
        showContactEmail
        showContactWebsite
        showContactAddress
        socialLinks {
          instagram
          facebook
          x
          youtube
        }
      }
    }
  }
`;

export const UPDATE_CLUB_WEBSITE_SETTINGS = `
  mutation updateClubWebsiteSettings(
    $clubId: String!
    $siteEnabled: Boolean
    $showStaff: Boolean
    $showRoster: Boolean
    $showEvents: Boolean
    $showPhotos: Boolean
    $showAttendance: Boolean
    $showPosts: Boolean
    $nameDisplay: String
    $showPlayerPhotos: Boolean
    $aboutText: String
    $showContactInfo: Boolean
    $showContactPhone: Boolean
    $showContactEmail: Boolean
    $showContactWebsite: Boolean
    $showContactAddress: Boolean
    $socialLinks: ClubSocialLinksInput
  ) {
    updateClubWebsiteSettings(
      clubId: $clubId
      siteEnabled: $siteEnabled
      showStaff: $showStaff
      showRoster: $showRoster
      showEvents: $showEvents
      showPhotos: $showPhotos
      showAttendance: $showAttendance
      showPosts: $showPosts
      nameDisplay: $nameDisplay
      showPlayerPhotos: $showPlayerPhotos
      aboutText: $aboutText
      showContactInfo: $showContactInfo
      showContactPhone: $showContactPhone
      showContactEmail: $showContactEmail
      showContactWebsite: $showContactWebsite
      showContactAddress: $showContactAddress
      socialLinks: $socialLinks
    ) {
      _id
    }
  }
`;

export const CLUB_SLUG_AVAILABLE = `
  query clubSlugAvailable($slug: String!, $excludeClubId: String) {
    clubSlugAvailable(slug: $slug, excludeClubId: $excludeClubId) {
      available
      reason
    }
  }
`;

export const UPDATE_CLUB_SLUG = `
  mutation updateClubSlug($clubId: String!, $slug: String!) {
    updateClubSlug(clubId: $clubId, slug: $slug) {
      _id
      slug
    }
  }
`;

const CLUB_DOMAIN_FIELDS = `
  _id
  hostname
  kind
  source
  status
  isPrimary
`;

export const GET_CLUB_DOMAINS = `
  query clubDomains($clubId: String!) {
    clubDomains(clubId: $clubId) {
      ${CLUB_DOMAIN_FIELDS}
    }
  }
`;

export const ADD_CLUB_DOMAIN = `
  mutation addClubDomain($clubId: String!, $hostname: String!, $kind: String!, $source: String) {
    addClubDomain(clubId: $clubId, hostname: $hostname, kind: $kind, source: $source) {
      ${CLUB_DOMAIN_FIELDS}
    }
  }
`;

export const REMOVE_CLUB_DOMAIN = `
  mutation removeClubDomain($clubId: String!, $domainId: String!) {
    removeClubDomain(clubId: $clubId, domainId: $domainId) {
      removed
    }
  }
`;

export const VERIFY_CLUB_DOMAIN = `
  mutation verifyClubDomain($clubId: String!, $domainId: String!) {
    verifyClubDomain(clubId: $clubId, domainId: $domainId) {
      ${CLUB_DOMAIN_FIELDS}
    }
  }
`;

export const GET_WEBSITE_TEAMS = `
  query GetWebsiteTeams($clubId: String!, $skip: Int, $limit: Int) {
    ClubTeams(clubId: $clubId, skip: $skip, limit: $limit) {
      _id
      name
      ageGroup
      season
      websiteEnabled
    }
  }
`;

export const SET_TEAMS_WEBSITE_ENABLED = `
  mutation setTeamsWebsiteEnabled($teamIds: [String!]!, $enabled: Boolean!) {
    setTeamsWebsiteEnabled(teamIds: $teamIds, enabled: $enabled) {
      _id
      websiteEnabled
    }
  }
`;

export const REGISTER_CLUB_USER = `
 mutation registerClubUser($firstName: String!, $lastName: String, $mobile: String, $email: String, $role: String!, $clubId: String, $teamId: String, $teamIds: [String!], $existingUserId: String, $lookupIdentity: String, $requireNewAccount: Boolean) {
  registerClubUser(firstName: $firstName, lastName: $lastName, mobile: $mobile, email: $email, role: $role, clubId: $clubId, teamId: $teamId, teamIds: $teamIds, existingUserId: $existingUserId, lookupIdentity: $lookupIdentity, requireNewAccount: $requireNewAccount) {
      _id
    }
  }
`;
